import React from 'react'
import { string, oneOf, bool } from 'prop-types'

export const DropdownArrow = ({ color, type, rotated }) => (
  <svg className={`${type}__arrow ` + (rotated ? `${type}__arrow--rotated` : '')} width='10' height='18' xmlns='http://www.w3.org/2000/svg'>
    <path d='M9.64 9.89l-7.55 7.75a1.2 1.2 0 0 1-1.73-.01 1.29 1.29 0 0 1 0-1.78L7.02 9 .35 2.14C-.1 1.64-.1.86.37.37A1.2 1.2 0 0 1 2.1.35L9.64 8.1a1.28 1.28 0 0 1 0 1.79z' fill={color} />
  </svg>
)

DropdownArrow.propTypes = {
  color: string,
  type: oneOf(['nav', 'dropdown', 'request']),
  rotated: bool
}

DropdownArrow.defaultProps = {
  color: '#B8BAC0'
}



// WEBPACK FOOTER //
// ./src/components/ui/buttons/DropdownArrow.js